import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@totalsoft/rocket-ui';

const Header = ({ documentTypeName }) => {
  const { t } = useTranslation();
  return (
    <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
      {t('DocumentTypes.DocumentWithStateTransitions.Title')}
      <i>{documentTypeName}</i>
    </Typography>
  );
};

Header.propTypes = {
  documentTypeName: PropTypes.string.isRequired
};

export default Header;
